let module = {
  /**
   * 把yyyy-mm-dd格式的日期转换为yyyy年mm月dd日
   * @param {Object} date
   */
  dateToCh: function(date) {
    var darray = date.split("-");
    return darray[0] + "年" + darray[1] + "月" + darray[2] + "日";
  },
  /**
   * 根据yyyymmdd格式的日期计算是星期几
   * @param {Object} yyyymmdd
   */
  dayOfWeek: function(yyyymmdd) {
    var dayCh = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
    if (typeof yyyymmdd == "string") {
      var dayInt = (new Date(yyyymmdd.substr(0, 4), parseInt(yyyymmdd.substr(4, 2)) - 1, yyyymmdd.substr(6, 2))).getDay();
      var day = dayCh[dayInt];
      return day;
    } else {
      return "";
    }
  },
  /**
   * 将yyyymmdd格式的日期转成mm-dd
   * @param {Object} date
   */
  mm_dd: function(yyyymmdd) {
    if (typeof yyyymmdd == "string") {
      return yyyymmdd.substr(4, 2) + "-" + yyyymmdd.substr(6, 2);
    } else {
      return yyyymmdd || "--";
    }
  },
  /**
   * 将yyyymmdd格式数据格式化为yyyy{symbo}mm{symbo}dd
   * @param {Object} yyyymmdd
   * @param {Object} symbo 符号
   */
  yyyy_mm_dd: function(yyyymmdd, symbo) { // 将yyyymmddd格式化为yyyy-mm-dd
    if (!symbo && symbo != '') symbo = '-';
    if (typeof yyyymmdd == "string") {
      return yyyymmdd.substr(0, 4) + symbo + yyyymmdd.substr(4, 2) + symbo + yyyymmdd.substr(6, 2);
    } else if (yyyymmdd instanceof Date) {
      var year = yyyymmdd.getFullYear();
      var month = yyyymmdd.getMonth() + 1;
      var strDate = yyyymmdd.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      return year + symbo + month + symbo + strDate;
    } else {
      return yyyymmdd || "--";
    }
  },
  /**
   * 将HHMMSS格式的时分秒格式化为HH:MM:SS或者HH:MM。
   * @param {Object} HHMMSS
   * @param {Object} option {HH:MM:SS|HH:MM}
   */
  HH_MM_SS: function(HHMMSS, option) { // 将HHMMSS格式化为HH:MM:SS
    option = option || "HH:MM:SS";
    if (typeof HHMMSS == "string") {
      if (option == "HH:MM:SS") {
        return HHMMSS.substr(0, 2) + ":" + HHMMSS.substr(2, 2) + ":" + HHMMSS.substr(4, 2);
      } else if (option == "HH:MM") {
        return HHMMSS.substr(0, 2) + ":" + HHMMSS.substr(2, 2);
      }
    } else {
      return HHMMSS || "--";
    }
  },
  /**
   * 14位日期字符串格式化
   * @param {String} date 日期字符串
   * @param {String} divider 分隔符
   */
  getDateTime: function (date, divider = '-') {
    if(!date) return 
    return date.replace(/^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/, ['$1', '$2', '$3'].join(divider) + ' $4:$5:$6')
  },
  /**
   * 日期字符串格式化
   * @param {String} date 日期字符串
   * @param {String} divider 分隔符
   */
  getDate: function (date, divider = '-') {
    if (date.length === 14) return this.getDateTime(date, divider)
    return date.replace(/(\d{4})[^\d]?(\d{2})[^\d]?(\d{2})/, ['$1', '$2', '$3'].join(divider))
  },
  /**
   * 获取某个日期加(负数则减)某个间隔后的日期
   * @param {Object} obj 日期偏移指数
   * @param {Date|String} date 日期或日期字符串
   * @param {Boolean} immutable 是否不改变原date对象，默认可改变
   */
  getOffsetDate: function (offsetObj, date, format, immutable) {
    offsetObj = offsetObj || {}
    if (immutable && this.isDate(date)) {
      date = new Date(date.valueOf())
    }
    if (date && typeof date === 'string') {
      date = new Date(this.getDate(date, '/'))
    }
    if (!this.isDate(date)) {
      date = new Date()
    }
    offsetObj.year && date.setYear(date.getFullYear() + (+offsetObj.year))
    offsetObj.month && date.setMonth(date.getMonth() + (+offsetObj.month))
    offsetObj.day && date.setDate(date.getDate() + (+offsetObj.day))
    return this.formatDate(date, format)
  },
  /**
   * 日期格式化
   * yyyy-mm-ss hh:mm:ss 替换为 年月日
   */
  toFormatDate: (dateStr) => {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  },
  /**
   * 日期格式化
   * 对比较复杂的日期格式进行格式化的时候使用，比如 星期几
   * @param {String} date 日期或日期字符串
   * @param {String} fmt 日期格式字符串
   */
  formatDate: (date, fmt = 'yyyy-MM-dd') => {
    if (!date) date = new Date()
    if (typeof date === 'string') {
      date = new Date(this.getDate(date))
    }
    var o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分钟
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      'S': date.getMilliseconds() // 毫秒
    }
    var week = {
      '0': '\u65e5', // 日
      '1': '\u4e00', // 一
      '2': '\u4e8c', // 二
      '3': '\u4e09', // 三
      '4': '\u56db', // 四
      '5': '\u4e94', // 五
      '6': '\u516d' // 六
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    if (/(E+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '\u661f\u671f' : '\u5468') : '') + week[date.getDay() + ''])
    }
    for (const k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt
  },
  getDateTimeArr: (date, divider = '-') => {
    return date.replace(/^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/, ['$1', '$2', '$3', '$4', '$5', '$6'].join(divider)).split(divider);
  },
  isDate: (date) => {
    return Object.prototype.toString.call(date) === '[object Date]'
  }
}
export default module;


// WEBPACK FOOTER //
// ./src/assets/utils/date-fmt.js